// extracted by mini-css-extract-plugin
export var closeButton = "_23-0";